import { type UseQueryResult, useQuery } from 'react-query';
import { RetirementEligibilityConfigurationService } from '../../services/wealthlane-award-settlement-services';
import { CustomerSuccessOptionsAppserviceService } from '../../services/wealthlane-customer-services';

const useGetRoleOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
      id: string;
    }>
  | undefined,
  unknown
> => {
  const roleOptions = useQuery(
    ['getRoleOptions'],
    async () => {
      return await handleRequest(
        CustomerSuccessOptionsAppserviceService.getApiCustomerApiCustomerCustomerSuccessOptionsSelfRoles()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.customerRoleId ?? '',
            id: item.id ?? '',
          };
        });
      },
    }
  );

  return roleOptions;
};

export default useGetRoleOptions;